import { useQuery } from '@tanstack/react-query';

import { getConsentDocuments } from '@/api/user';

import { useAppSelector } from '@/hooks/redux';

import { selectUser } from '@/redux/user-data';

import { ConsentType } from '@/types/api/user';

import { isRemediationCustomer } from '@/utils/user';

export const getConsentDocumentsQueryKey = (operationId?: string) => [
  'consent-documents',
  operationId,
];

export function useConsentDocuments(enabled = true) {
  const user = useAppSelector(selectUser);

  return useQuery({
    queryKey: getConsentDocumentsQueryKey(user?.operationId),
    queryFn: getConsentDocuments,
    enabled,
    refetchOnWindowFocus: false,
    select: data => {
      if (isRemediationCustomer(user)) {
        return data.filter(
          document => document.consentType !== ConsentType.ElectronicBanking,
        );
      }
      return data;
    },
  });
}
